import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { CircularProgress, Box } from "@mui/material";

interface ProtectedPlayerRouteProps {
  children: React.ReactNode;
}

function ProtectedPlayerRoute({ children }: ProtectedPlayerRouteProps) {
  const { isPlayer, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isPlayer) {
    // Save the current path to redirect after login
    localStorage.setItem("redirectAfterLogin", window.location.pathname);
    return <Navigate to="/player/login" replace />;
  }

  return <>{children}</>;
}

export default ProtectedPlayerRoute;
